// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2--mZ","item":"PaymentsMobile_item__Y7_gu","label":"PaymentsMobile_label__19M1t","amount":"PaymentsMobile_amount__3zUNe"};